import React from 'react';
import { string, bool, func } from 'prop-types';
import classnames from 'classnames';
import { productShape } from 'shapes';
import { Icons } from 'components';
import './WishlistButton.scss';

export default function WishlistButton({
    className,
    active,
    onClick,
    product,
    isB2B,
}) {
    const rootClassnames = classnames(className, 'wishlist-button');

    const handleClick = event => {
        event.preventDefault();
        if (onClick) {
            onClick(event);
        }
    };

    let icon = <Icons.Heart />;

    if (isB2B) {
        if (active) {
            icon = <Icons.ListFilled />;
        } else {
            icon = <Icons.List />;
        }
    } else if (active) {
        icon = <Icons.HeartFilled />;
    }

    return (
        <button
            className={rootClassnames}
            onClick={handleClick}
            data-name={product.title}
            data-rating={product.rating}
            data-ratting-count={product.ratingCount}
            data-url={product.url}
            data-image={product.image_fullpath}
            data-quantity={product.minQuantity || 1}
            data-product-id={product.objectID}
            data-price={product.price}
            data-article-id={product.article_id}
            data-product-brand={product.brand_name}
            data-category-id={product['categories.last_id']}
            data-has-x-payment={product.has_3x_payment ? 'true' : 'false'}
            data-event="add_to_wishlist"
            data-event-trigger="listing"
            data-qa="wishlistIconCta"
        >
            {icon}
        </button>
    );
}

WishlistButton.propTypes = {
    className: string,
    active: bool,
    onClick: func,
    product: productShape.isRequired,
    isB2B: bool,
};

WishlistButton.defaultProps = {
    className: '',
    active: false,
    onClick: null,
    isB2B: false,
};
